class InfiniteScrollComponent extends HTMLElement {
    constructor() {
        super();

        // Create a wrapper div to hold the items and loading spinner
        this.wrapper = document.createElement('div');
        this.wrapper.className = 'q-infinite-scroll-wrapper';

        // Create a container to hold the items
        this.itemContainer = document.createElement('div');
        this.itemContainer.className = 'item-container';

        // Add custom classes from the "class" attribute to the item container
        const customClasses = this.getAttribute('class');
        if (customClasses) {
            // Split the classes by spaces, trim each class name, and filter out any empty entries
            const classList = customClasses.split(' ')
                .map(className => className.trim())  // Remove extra spaces or newlines
                .filter(className => className.length > 0);  // Only keep non-empty class names
            try {
                this.itemContainer.classList.add(...classList);
            }catch (e){
                console.error(e)
            }
        }

        // Create a loading spinner
        this.loadingSpinner = document.createElement('div');
        this.loadingSpinner.className = 'loading-spinner';
        this.loadingSpinner.style.textAlign = 'center';
        this.loadingSpinner.style.margin = '1rem 0';

        // Create the loading image
        const loadingImage = document.createElement('img');
        loadingImage.src = '../../../../qawafil/theme-assets/images/spinner.svg'; // Replace with the actual URL to your loading image
        loadingImage.alt = 'Loading...';
        loadingImage.style.width = '70px'; // Adjust size as needed
        loadingImage.style.height = '70px'; // Adjust size as needed

        // Append the loading image to the spinner div
        this.loadingSpinner.appendChild(loadingImage);

        // Append the container and spinner to the wrapper
        this.wrapper.appendChild(this.itemContainer);
        this.wrapper.appendChild(this.loadingSpinner);



        // Set up properties
        this.originalNextPageUrl = this.getAttribute('next-page'); // Store the original next page URL
        this.nextPageUrl = this.originalNextPageUrl; // Initialize with the original next page URL
        this.templateFile = this.getAttribute('template-file');
        this.as = this.getAttribute('as');
        this.loading = false; // To prevent multiple requests during loading
        this.loadingSpinner.style.display = 'none'; // Hide loading spinner

        // Event listener for infinite scrolling
        window.addEventListener('scroll', () => this.handleScroll());

        // Count the initial number of items
        this.initialItemsCount = this.children.length;
        this.perPage = this.initialItemsCount;

    }

    connectedCallback() {
        // Move the initial items directly to the light DOM
        this.replaceWithContent();

        if(this.initialItemsCount === 0){
            this.loadMoreItems(1);
        }
    }

    // Function to replace the custom element with its content
    replaceWithContent() {

        // Move all child nodes from the custom element to the fragment
        while (this.firstChild) {
            this.itemContainer.appendChild(this.firstChild)
        }

        // Create a document fragment to hold the nodes temporarily
        const fragment = document.createDocumentFragment();
        // Append the wrapper to the custom element
        fragment.appendChild(this.wrapper);

        /*// Replace the custom element itself with its content
        this.parentNode.replaceChild(fragment, this);*/

        // Append the wrapper to the custom element itself
        this.appendChild(fragment);
    }

    // Handle scroll event and fetch new data when the user reaches the bottom
    handleScroll() {
        const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
        const threshold = 300; // Load more items when the user is 300px away from the bottom
        if (scrollTop + clientHeight >= scrollHeight - threshold && this.nextPageUrl && !this.loading) {
            this.loadMoreItems();
        }
    }

    // Fetch and append more items to the list
    async loadMoreItems(page = null) {
        if (!this.nextPageUrl) return;

        this.loading = true; // Prevent multiple requests during loading
        this.loadingSpinner.style.display = 'block'; // Show loading spinner

        try {
            // Include the template file name in the fetch request
            const url = new URL(this.nextPageUrl, window.location.origin);
            QawafilPreviewNavigation.addCapabilityToUrl(url, QawafilStore.previewCapability);
            url.searchParams.append('templateFile', this.templateFile);
            url.searchParams.append('templateName', QawafilStore.templateName);
            url.searchParams.append('as', this.as);
            if(page) url.searchParams.append('page', page);
            if(this.perPage > 0) url.searchParams.append('per_page', this.perPage); // Store this value for later use

            const response = await fetch(url, {
                method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Accept-Language': localStorage.getItem('locale') || 'ar',
                        'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
                        'X-Storefront-Token': document.querySelector('meta[name="sf-token"]')?.content || ''
                    },
                    credentials: 'include'
            });
            const jsonRes = await response.json(); // Expecting the server to return rendered HTML

            // Parse the new HTML content and append it to the item container
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = jsonRes.data.items;
            const newItems = tempDiv.children;

            if(page === 1) this.itemContainer.innerHTML = '';
            Array.from(newItems).forEach(item => {
                this.itemContainer.appendChild(item);
            });

            // Update the nextPageUrl based on the server's response
            this.nextPageUrl = jsonRes.data.next_page_url;
            this.perPage = jsonRes.data.per_page;

        } catch (error) {
            console.error('Error fetching more items:', error);
        } finally {
            this.loading = false; // Reset loading status
            this.loadingSpinner.style.display = 'none'; // Hide loading spinner
        }
    }

    // Extract the next page URL from the fetched data (assuming it contains a data attribute)
    extractNextPageUrl(container) {
        const nextPageElement = container.querySelector('[next-page]');
        return nextPageElement ? nextPageElement.getAttribute('next-page') : null;
    }


    // Reinitialize the component to refresh pagination when an item is added or removed
    reinit() {
        console.log("Infinite scroll: reinit")
        // Clear the existing items and reset the state
        this.nextPageUrl = this.originalNextPageUrl;
        this.initialItemsCount = 0;
        this.perPage = 0;
        this.loading = false;

        // Reload the initial items
        this.loadMoreItems(1);

    }

}

// Define the custom element
customElements.define('infinite-scroll', InfiniteScrollComponent);
